import { GeneralCommonsModule } from '@/src/app/shared/modules/general-commons/general-commons.module';
import { CommonModule, AsyncPipe } from '@angular/common';
import { Component, NgModule, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReportConfig, ReportDownloadTypes } from '../../components/report-filters/models/report-filters.model';
import { ReportFiltersModule, ReportFiltersComponent } from '../../components/report-filters/report-filters.component';
import { ReportTableDataService } from '../../components/report-filters/services/report-table-data.service';
import { ReportService } from '../../components/report-filters/services/report.service';
import { ReportHeaderComponent } from '../../components/report-header/report-header.component';
import {
  SurgicalFollowUpVisitsReportTableComponentModule,
  SurgicalFollowUpVisitsReportTableComponent
} from './components/surgical-follow-up-visits-report-table/surgical-follow-up-visits-report-table.component';
import { PaginationSortingModel } from '@shared/components/table/models/pagination-sorting.model';
import { GenericWidePageComponent } from '@shared/modules/general-commons/components/generic-page-wide/generic-wide-page.component';

@Component({
  selector: 'stx-surgical-follow-up-visits-report',
  templateUrl: './surgical-follow-up-visits-report.component.html',
  imports: [
    GenericWidePageComponent,
    ReportHeaderComponent,
    ReportFiltersComponent,
    SurgicalFollowUpVisitsReportTableComponent,
    TranslateModule,
    AsyncPipe
  ]
})
export class SurgicalFollowUpVisitsReportComponent {
  reportService = inject(ReportService);
  private reportTableDataService = inject(ReportTableDataService);

  readonly reportConfig: ReportConfig = {
    type: 'SURGICAL_FOLLOW_UP_VISITS',
    downloadOptions: {
      [ReportDownloadTypes.EXCEL]: true
    },
    filters: {
      age: true,
      gender: true,
      geography: true,
      organizationsTree: true,
      recordDate: true,
      status: true
    }
  };

  applyFilters(pagination: PaginationSortingModel) {
    this.reportTableDataService.prepareList('SURGICAL_FOLLOW_UP_VISITS', this.reportService.model, pagination);
  }
}

@NgModule({
  imports: [
    ReportFiltersModule,
    TranslateModule,
    CommonModule,
    SurgicalFollowUpVisitsReportTableComponentModule,
    GeneralCommonsModule,
    SurgicalFollowUpVisitsReportComponent
  ],
  exports: [SurgicalFollowUpVisitsReportComponent]
})
export class SurgicalFollowUpVisitsReportComponentModule {}
